import * as React from 'react';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import { IntlLanguageKey, IntlLanguages } from './IntlLanguages';

// Locale
import './prepareIntl';

export interface IIntlProviderProps {
  children: React.ReactNode;
}

/**
 * Coordina le traduzioni applicative, a partire da `i18next` che viene caricato
 * tramite l'import presente sopra (`prepareIntl`), per passare al Locale di ant,
 * che viene assegnato dinamicamente in base alla lingua selezionata dall'utente.
 *
 * Il cambiamento della lingua viene gestito in `prepareIntl` all'evento
 * `languageChanged` di i18next.
 */
export function IntlProvider(props: IIntlProviderProps) {
  const { i18n } = useTranslation();

  const current = IntlLanguages[i18n.language as IntlLanguageKey];

  return <ConfigProvider locale={current.ant}>{props.children}</ConfigProvider>;
}
